export const fieldNotEmpty = val => {
  return { hasError: !val, errorText: 'Field cannot be empty' };
};

export const dateNotInPast = dateString => {
  const date = new Date(dateString);
  const currentDate = new Date();
  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);

  return {
    hasError: date <= yesterday,
    errorText: 'Date cannot be in the past'
  };
};

export const isValidMobileNumber = val => {
  const regexStr = new RegExp('^[0-9]{10}$');
  return {
    hasError: !regexStr.test(val),
    errorText: 'Invalid! enter 10 digit mobile no.'
  };
};

export const containsOnlyAlphabets = val => {
  const regexStr = new RegExp('^[a-zA-Z]+$');
  return {
    hasError: !regexStr.test(val),
    errorText: 'Only alphabets are allowed'
  };
};
